import React, { useEffect, useState } from 'react';
import { fetchTermsAndConditions } from '../../Providers/staticFileProvider';
import axios from 'axios';
import Navbar from '../Navbar/navbar';
import Footer from '../Footer/footer';
import FooterDoodles from '../Footer/footerDoodles';
import icons from '../../icons.config';

const TermsAndConditions = () => {
  const [termsAndConditions, setTermsAndConditions] = useState("");

  useEffect(() => {
    const getTermsAndConditions = async () => {
      const data = await fetchTermsAndConditions();
      if (data) setTermsAndConditions(data);
    };
    getTermsAndConditions();
  }, []);

  useEffect(() => {
    const fetchTermsAndConditions = async () => {
      try {
        console.log("Fetching terms and conditions");
        const response = await axios.get(
          `${process.env.REACT_APP_API_BASE_URL}/termsandconditions/getTermsAndConditions`
        );
        console.log("API Response:", response);
        console.log("API Data:", response.data);
  
        // Correctly accessing the nested data
        if (response.data && response.data.success && response.data.data.terms_and_conditions) {
          setTermsAndConditions(response.data.data.terms_and_conditions);
        } else {
          console.error("Unexpected API response format:", response.data);
        }
      } catch (error) {
        console.error("Error fetching Terms and Conditions:", error);
      }
    };
  
    fetchTermsAndConditions();
  }, []);
  return (
    <>
      <Navbar />
      <section className="flex flex-col justify-center items-center w-full h-full bg-tertiary pt-10 md:pt-3 lg:pt-0 lg:-mt-5 relative pb-0 overflow-hidden">
        <div className="lg:block relative left-[60%] md:left-[45%] lg:left-[45%] z-10">
          <img src={icons.trendCircles} alt="Doodle Left" className="w-[40%] md:w-[60%] lg:w-[70%]" />
        </div>
      </section>

      <section className="bg-tertiary">
        <div className="flex justify-center items-center relative bottom-12 md:bottom-14 lg:bottom-24">
          <h1 className="text-primary1 font-outfit text-2xl md:text-3xl lg:text-4xl font-light">
            TERMS AND CONDITIONS
          </h1>
        </div>

        <div className="px-12 md:px-12 lg:px-24 xl:px-32 text-left z-20 pb-10 lg:-mt-10">
          {termsAndConditions ? (
            <p className="text-base text-gray-700 mt-2 whitespace-pre-line">{termsAndConditions}</p>
          ) : (
            <p className="text-gray-500">Loading terms and conditions...</p>
          )}
        </div>
      </section>

      <FooterDoodles />
      <Footer />
    </>
  );
};

export default TermsAndConditions;
